import React from "react";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  FiClock,
  FiCompass,
  FiMessageSquare,
  FiShield,
  FiTrendingUp,
  FiX,
  FiHome,
} from "react-icons/fi";
import { FaStar } from "react-icons/fa";
import "./comingSoon.scss";

export interface ComingSoonModalProps {
  show?: boolean;
  onHide?: () => void;
  title?: string;
  subtitle?: string;
  isPage?: boolean;
}

const ComingSoonModal: React.FC<ComingSoonModalProps> = ({
  show,
  onHide,
  title = "Investor Forum",
  subtitle = "We're building an exclusive, collaborative space for verified investors and entrepreneurs to exchange strategic insights, discuss deal flow, and explore partnerships.",
  isPage = false,
}) => {
  const navigate = useNavigate();

  const handleBackHome = () => {
    if (onHide) onHide();
    navigate("/");
  };

  const cardContent = (
    <div className={`coming-soon-card ${isPage ? "is-page-card" : ""}`}>
      {onHide && !isPage && (
        <button
          type="button"
          className="coming-soon-close-btn"
          onClick={onHide}
          aria-label="Close"
        >
          <FiX size={18} />
        </button>
      )}

      {/* Prominently Highlighted Coming Soon Badge */}
      <div className="coming-soon-highlight-badge">
        <span className="badge-pulse-dot" />
        <span className="badge-text">
          <FaStar size={11} className="me-1" style={{ color: "#66C15E" }} /> COMING SOON
        </span>
      </div>

      {/* Brand Icon Graphic */}
      <div className="coming-soon-icon-wrapper">
        <div className="coming-soon-icon-inner">
          <FiMessageSquare className="coming-soon-icon" />
        </div>
      </div>

      {/* Heading with Brand Color & Highlighted Tag */}
      <h2 className="coming-soon-title">
        {title}
        <span className="coming-soon-title-tag">Coming Soon</span>
      </h2>

      <p className="coming-soon-description">{subtitle}</p>

      {/* Feature Preview Mini-Cards */}
      <div className="coming-soon-features-grid">
        <div className="feature-mini-card">
          <div className="feature-mini-icon">
            <FiTrendingUp size={16} />
          </div>
          <div className="feature-mini-info">
            <h6 className="feature-mini-title">Deal-Flow & Trends</h6>
            <p className="feature-mini-desc">
              Explore market opportunities, discussions & startup intelligence.
            </p>
          </div>
        </div>

        <div className="feature-mini-card">
          <div className="feature-mini-icon">
            <FiShield size={16} />
          </div>
          <div className="feature-mini-info">
            <h6 className="feature-mini-title">Accredited Network</h6>
            <p className="feature-mini-desc">
              High-signal discussions in a trusted, secure investor ecosystem.
            </p>
          </div>
        </div>

        <div className="feature-mini-card">
          <div className="feature-mini-icon">
            <FiCompass size={16} />
          </div>
          <div className="feature-mini-info">
            <h6 className="feature-mini-title">Strategic Co-Investment</h6>
            <p className="feature-mini-desc">
              Form syndicates, connect with co-investors & exchange deal notes.
            </p>
          </div>
        </div>
      </div>

      {/* Single Brand Action Button using project btn-primary */}
      <div className="coming-soon-actions">
        {isPage ? (
          <button
            type="button"
            className="btn btn-primary coming-soon-brand-btn"
            onClick={handleBackHome}
          >
            <FiHome size={16} className="me-2" /> Back to Home
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-primary coming-soon-brand-btn"
            onClick={onHide}
          >
            Got It, Stay Tuned
          </button>
        )}
      </div>
    </div>
  );

  if (isPage) {
    return (
      <div className="coming-soon-page-wrapper">
        {cardContent}
      </div>
    );
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="coming-soon-modal"
      dialogClassName="coming-soon-modal-dialog"
      contentClassName="coming-soon-modal-content"
    >
      <Modal.Body className="p-0">{cardContent}</Modal.Body>
    </Modal>
  );
};

export default ComingSoonModal;
